import "./styles/styles.less"
import {useLocation, useNavigate} from "react-router";
import {Flex, Layout, Menu, notification} from "antd";
import { PiArrowArcLeftBold } from "react-icons/pi";
import {PiStudentFill} from "react-icons/pi";
import PageContainer from "./PageContainer";
import {MenuInfo} from "rc-menu/lib/interface";
import Sider from "antd/es/layout/Sider";
import {useEffect, useState} from "react";
import MainHeader from "./MainHeader";
import {userStore} from "../store/store";
import {MdMenuOpen, MdOutlineCurrencyRuble} from "react-icons/md";
import {getRequest} from "../api/httpRequest";
import {IoMenu} from "react-icons/io5";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {GrDocumentVerified, GrFolderOpen, GrLineChart, GrSchedule, GrTask, GrUserExpert} from "react-icons/gr";
import {FaMedal} from "react-icons/fa";
import { RiUserSettingsFill } from "react-icons/ri";

const iconSize = 20
const menuItems = [
    {
        key: "tasks",
        icon: <GrTask size={iconSize}/>,
        label: "Задачи",
        roles: [
            {
                role: "TEACHER"
            },
            {
                role: "STUDENT"
            }
        ],
    },
    {
        key: "calendar",
        icon: <GrSchedule size={iconSize}/>,
        label: "Расписание",
        roles: [
            {
                role: "TEACHER"
            },
            {
                role: "STUDENT"
            }
        ],
    },
    {
        key: "plans",
        icon: <GrLineChart size={iconSize}/>,
        label: "Инд. планы",
        roles: [
            {
                role: "TEACHER"
            }
        ],
    },
    {
        key: "education",
        label: "Обучение",
        icon: <PiStudentFill size={iconSize}/>,
        roles: [
            {
                role: "STUDENT"
            }],
    },
    {
        key: "statements",
        icon: <GrDocumentVerified size={iconSize}/>,
        label: "Ведомости",
        roles: [
            {
                role: "TEACHER"
            }
        ],
    },
    {
        key: "salarys",
        icon: <MdOutlineCurrencyRuble size={iconSize}/>,
        label: "Зарплата",
        roles: [
            {
                role: "EMPLOYEE"
            }
        ],
    },
    {
        key: "orders",
        icon: <MdOutlineCurrencyRuble size={iconSize}/>,
        label: "Приказы",
        roles: [
            {
                role: "EMPLOYEE"
            }
        ],
    },
    {
        key: "admission",
        icon: <GrUserExpert size={iconSize}/>,
        label: "Поступление",
        roles: [
            {
                role: "TEACHER"
            },
            {
                role: "OTHER"
            },
            {
                role: "STUDENT"
            }
        ],
    },
    {
        key: "documents",
        icon: <GrFolderOpen size={iconSize}/>,
        label: "Договоры",
        roles: [
            {
                role: "TEACHER"
            },
            {
                role: "STUDENT"
            },
            {
                role: "OTHER"
            }
        ],
    },
    {
        key: "olympiad",
        icon: <FaMedal size={iconSize}/>,
        label: "Олимпиады",
        roles: [
            {
                role: "HIDE"
            }
        ],
    },
    {
        key: "old",
        icon: <PiArrowArcLeftBold  size={iconSize}/>,
        label: "В старый ЛК",
        roles: [
            {
                role: "EMPLOYEE"
            }
        ],
    },
    {
        key: "users",
        icon: <RiUserSettingsFill  size={iconSize}/>,
        label: "Пользователи",
        roles: [
            {
                role: "ADMIN"
            }
        ],
    }
]

export default function MainContainer() {

    const navigate = useNavigate()
    const location = useLocation()
    const {user, setUser} = userStore();
    const [api, contextHolder] = notification.useNotification();
    const [collapsed, setCollapsed] = useState(false)
    const [selectedKey, setSelectedKey] = useState<string>(() => {
        const path = location.pathname.replace("/", "")
        return path || ""
    })
    const {xl} = useBreakpoint()

    useEffect(() => {

        const checkTasks = async () => {
            getRequest("/server/1c/lc/v1/tasks/count")
                .then(response => {
                    const count = response.data.count
                    setTimeout(() => {
                        if (count > 0) {
                            api.warning({
                                message: `Имеются открытые задачи: ${count}`,
                                duration: 3
                            });
                        }
                    }, 1000)
                })
        }

        getRequest("/server/user")
            .then(response => {
                setUser({
                    ...response.data,
                    id_e: response.data.idE,
                    birth: response.data.dateBirth
                })

                const roles = response.data.roles as string[]
                const hasRole = (role: string) => roles.includes(role)

                let targetPath: string | null = null
                if (hasRole("EMPLOYEE")) {
                    targetPath = "/salarys"
                } else if (hasRole("TEACHER")) {
                    targetPath = "/tasks"
                    // Проверка задач только для TEACHER
                    checkTasks()
                } else if (hasRole("OTHER")) {
                    targetPath = "/admission"
                } else if (hasRole("STUDENT")) {
                    targetPath = "/work-in-progress"
                } else if (hasRole("ADMIN")) {
                    targetPath = "/users"
                }

                const currentPath = location.pathname
                const isLoginPage = currentPath.startsWith("/login")
                const isRootPage = currentPath === "/"

                if (targetPath && (isLoginPage || isRootPage)) {
                    navigate(targetPath)
                }
            }).catch(error => {
            console.log(error)
            navigate("/login")
            api.warning({
                message: `Ошибка получения данных о пользователе`,
                duration: 3
            });
        })

    }, []);

    useEffect(() => {
        const path = location.pathname.replace("/", "")
        if (path) {
            setSelectedKey(path)
        }
    }, [location.pathname]);

    const handleMenuClick = (menuItem: MenuInfo) => {

        if (menuItem.key === "library") {
            window.open('https://library.miit.ru/')
            return
        }

        if (menuItem.key === "old") {
            window.open('https://rut-miit.ru/cabinet/hello/login.jsp')
            return
        }

        if (!xl) {
            setCollapsed(!collapsed)
        }
        navigate(`/${menuItem.key}`)
    }

    const filterMenuItems = () => {

        return menuItems.filter(menuItem => {
            const userRoles = user.roles
            let exists;
            menuItem.roles.forEach(menuItemRole => {
                userRoles.forEach(userRole => {
                    if (userRole === menuItemRole.role) {
                        exists = true
                    }
                })
            })
            return exists
        })
    }

    return (
        <Layout className={"mainLayout"} hasSider={true}>
            {contextHolder}
            <MainHeader/>
            <Sider
                className={xl ? "fixed-sider" : "sider-container"}
                breakpoint="sm"
                collapsedWidth="0"
                collapsed={collapsed}
                zeroWidthTriggerStyle={{position: "absolute", top: -50, left: 10, border: "none"}}
                trigger={
                    <Flex className={"sider-trigger"}>
                        {collapsed ?
                            <IoMenu size={"24"}/>
                            :
                            <MdMenuOpen size={"24"}/>
                        }
                    </Flex>
                }
                onCollapse={() => setCollapsed(!collapsed)}
                theme={"light"}
            >
                <Menu
                    theme="light"
                        mode="inline"
                        selectedKeys={[selectedKey]}
                        items={filterMenuItems()}
                        onClick={(menuItem) => handleMenuClick(menuItem)}
                    />
                </Sider>
            <Layout className={xl ? "layout-with-sider" : "layout-main-offset"}>
                <PageContainer/>
            </Layout>
        </Layout>
    )
}